export const apiUrl = "http://www.odontoapi.rocazit.com";
// export const apiUrl = "http://127.0.0.1:8000";
export const drName= "Dra. Daniela Ureña";